import { FC } from 'react';

import PaypalAdd from 'components/paypal-add';

const PaypalMethod: FC = (): JSX.Element => <PaypalAdd />;

export default PaypalMethod;
